const HEX_HASH = /^0x[0-9a-f]+$/i;
// A BTC or Tron txid: bare hex, so case carries nothing.
const BARE_TXID = /^[0-9a-f]{64}$/i;

/** Hex hashes compare lowercased; base58 and other encodings are case-sensitive, so stay as sent. */
export function canonicalTxHash(hash: string): string {
  const trimmed = hash.trim();
  return HEX_HASH.test(trimmed) || BARE_TXID.test(trimmed) ? trimmed.toLowerCase() : trimmed;
}

export const canonicalTxHashOrNull = (hash: string | null | undefined): string | null =>
  hash ? canonicalTxHash(hash) || null : null;
